import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

function StepByStepWrapper({
  number,
  isActive,
  header,
  title,
  component,
  // default
  className,
  children,
}) {
  const mainClassNames = classNames('step-by-step-wrapper', className);

  return (
    isActive && (
      <div key={`step-${number && number}`} className={mainClassNames}>
        <div className="step-by-step-wrapper__header">
          {header && <h4 className="header-counter">{header}</h4>}
          {title && <h3 className="header-title">{title}</h3>}
        </div>
        {component || children}
      </div>
    )
  );
}

StepByStepWrapper.defaultProps = {
  header: 'Step Wrapper',
};

StepByStepWrapper.defaultProps = {};
StepByStepWrapper.propTypes = {
  isActive: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
  header: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
};

export default memo(StepByStepWrapper);
